import { lazy } from 'react';

export const Test = lazy(() => import('../nodes/Test'));

// 首页
export const Home = lazy(() => import('../nodes/home'));
export const Social = lazy(() => import('../nodes/social'));
export const PositionDetail = lazy(() => import('../nodes/positionDetail'));
export const Position = lazy(() => import('../nodes/position'));
export const Campus = lazy(() => import('../nodes/campus'));
// export const CampusBole = lazy(() => import('../nodes/campusBole'));
export const Question = lazy(() => import('../nodes/question'));
// export const CampusTv = lazy(() => import('../nodes/campus/tv'));
export const CampusSchedule = lazy(() => import('../nodes/CampusSchedule'));

// 北斗页
export const Beidou = lazy(() => import('../nodes/beidou'));
// 新北斗
export const BeiDouProgram = lazy(() => import('../nodes/beidouProgram'));

// 启航页
export const QiHang = lazy(() => import('../nodes/qihang'));

// 管培生页
export const Trainee = lazy(() => import('../nodes/trainee'));

// 分享list
export const SharePosition = lazy(() => import('../nodes/sharePosition'));

// // 个人中心/账号设置
export const AccountSetting = lazy(() => import('../nodes/personalCenter/wrapper'));
export const About = lazy(() => import('../nodes/about'));
export const DeliveryConfirm = lazy(() => import('../nodes/deliveryConfirm'));

// 登录
export const Login = lazy(() => import('../nodes/login'));
// 登录后简历确认
export const ResumeConfirm = lazy(() => import('../nodes/resumeConfirm'));
// 预览简历
export const PreViewResume = lazy(() => import('../nodes/personalCenter/resumeDetail/preViewResume'));

// 投递成功
export const DeliverySuccess = lazy(() => import('../nodes/deliverySuccess'));

// AI-Coding
export const AICoding = lazy(() => import('../nodes/nocode'));
